import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Achievement = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2024 - 2025</p>
          <h2 className="text-3xl md:text-4xl font-bold">Security Achievements</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-auto border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="ThreatEye - Vulnerability Scanner"
            subTitle="FastAPI Security Tool"
            result="Production Ready"
            des="Built FastAPI-based web vulnerability scanner detecting missing security headers, open redirects, and reflected inputs with JWT RBAC authentication."
          />
          <ResumeCard
            title="API Security Testing - Production Impact"
            subTitle="IntalksAI Backend"
            result="2 Critical Bugs Caught Before Deployment"
            des="Identified and documented authentication gaps on internal API routes using Postman before they reached production environment."
          />
          <ResumeCard
            title="WordPress Security Audit"
            subTitle="DigitalDose Client Projects"
            result="4 SQL Injection Vulnerabilities Fixed"
            des="Audited WordPress contact forms for SQL injection; rewrote 4 raw query blocks using prepared statements and server-side sanitization."
          />
        </div>
      </div>
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2024 - 2025</p>
          <h2 className="text-3xl md:text-4xl font-bold">Project & Career Milestones</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-auto border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="VNC Exfiltration Detection System"
            subTitle="ML-Based Network Anomaly Detection"
            result="91% Accuracy Achieved"
            des="Developed Random Forest classifier analyzing PCAP files with Scapy. Built Streamlit dashboard for visualization and interpretability."
          />
          <ResumeCard
            title="GDG Lead - Community Impact"
            subTitle="IILM University (Aug 2024 - Sep 2025)"
            result="50+ Students Mentored, 2 Hackathons Organized"
            des="Delivered 6+ workshops on Linux, REST APIs, Secure Coding, and OWASP Top 10. Mentored 8 teams in application development."
          />
          <ResumeCard
            title="Competitive Achievements"
            subTitle="Hackathons & Competitions"
            result="2nd Place - NIET Hackathon, 1st Prize - Web Design (IILM)"
            des="Secured 2nd runner-up in hackathons demonstrating innovation, teamwork, and ability to deliver high-quality solutions under pressure."
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Achievement;
